import { render } from "./DetailStoreHeader.vue?vue&type=template&id=6f7c7592&scoped=true"
import script from "./DetailStoreHeader.vue?vue&type=script&lang=js"
export * from "./DetailStoreHeader.vue?vue&type=script&lang=js"

import "./DetailStoreHeader.vue?vue&type=style&index=0&id=6f7c7592&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7c7592"]])

export default __exports__